const WORDS = [
  "Life Insurance",
  "Healthcare Solutions",
  "Mortgage Protection",
  "LegalShield",
  "Retirement Planning",
  "Tax Services",
];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-[#bf953f]/15 bg-[#0a192f] py-8 overflow-hidden"
    >
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-display italic text-3xl md:text-5xl text-gold-gradient px-8">
              {w}
            </span>
            <span className="text-[#bf953f]/50 text-2xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
